import { render, staticRenderFns } from "./orderTemplate.vue?vue&type=template&id=8f67fbe6&"
import script from "./orderTemplate.vue?vue&type=script&lang=js&"
export * from "./orderTemplate.vue?vue&type=script&lang=js&"
import style0 from "./orderTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f67fbe6')) {
      api.createRecord('8f67fbe6', component.options)
    } else {
      api.reload('8f67fbe6', component.options)
    }
    module.hot.accept("./orderTemplate.vue?vue&type=template&id=8f67fbe6&", function () {
      api.rerender('8f67fbe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/orderTemplateConfig/orderTemplate.vue"
export default component.exports